<template>
	<div class="home">
		<el-carousel trigger="click" height="600px">
			<el-carousel-item v-if="!isMobile">
				<div class="hero-container hero-container1">
					<div class="hero-content">
						<div class="footer-container">
							<div class="countdown-box" v-if="showTime">
								<span class="countdown-label">倒计时</span>
								<span class="countdown-text">还有</span>
								<span class="countdown-number">{{ day }}</span>
								<span class="countdown-text">天</span>
								<span class="countdown-timer">{{ hour }}：{{ min }}：{{ second }}</span>
							</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="hero-container">
					<div class="hero-content">
						<h1 class="main-title">中国企业走出去风险发布会</h1>
						<p class="sub-title">全球风险、全球发布、全球商机、全球服务</p>
						
						<div class="stats-container">
							<div class="stat-box" v-for="(item, index) in loopData0" :key="index">
								<div class="stat-number" v-html="item.lanhutext0"></div>
								<div class="stat-label" v-html="item.lanhutext1"></div>
							</div>
						</div>
						
						<div class="footer-container">
							<div class="countdown-box" v-if="showTime">
								<span class="countdown-label">倒计时</span>
								<span class="countdown-text">还有</span>
								<span class="countdown-number">{{ day }}</span>
								<span class="countdown-text">天</span>
								<span class="countdown-timer">{{ hour }}：{{ min }}：{{ second }}</span>
							</div>
							<div class="year-range">2015～2025</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
		

		<!-- 国际性-专业性-公益性-民间性 -->
		<section class="features-section">
			<div class="container">
				<div class="features-grid">
					<div class="feature-card">
						<h3 class="feature-title">国际性</h3>
						<p class="feature-text">以"全球风险、全球发布、全球商机、全球服务"为理念，聚焦"一带一路"沿线风险，发布五大洲年度风险版图，为跨境企业提供安全指引。累计邀请400余位国际专家、驻华使节及国际组织代表参与，与100+驻华机构建立交流机制，落地北京、上海等国际化城市，单场吸引数千中外人士参会。</p>
					</div>
					
					<div class="feature-card">
						<h3 class="feature-title">专业性</h3>
						<p class="feature-text">围绕企业出海核心痛点，提供法律、税务、金融等领域专业风控建议。同期举办全球投资论坛与救援服务论坛，组织350余场专家演讲，覆盖全链条风险议题。联合30多个省市商务部门设立分会场，出版11本《全记录》，成为海外风险研究权威资料。</p>
					</div>
					
					<div class="feature-card">
						<h3 class="feature-title">公益性</h3>
						<p class="feature-text">坚持零商业运作，未收取广告或赞助费用，疫情期间仍持续举办。累计服务5600余家企业，线上触达3.4亿人次，获中央及地方媒体600余次报道，新浪等开设专题跟踪，打造全球知名公益品牌。</p>
					</div>
					
					<div class="feature-card">
						<h3 class="feature-title">民间性</h3>
						<p class="feature-text">以"为企业解困、为政府分忧"为宗旨，动态响应企业需求，依托江泰国际合作联盟与全球救援联盟提供市场化精准风险管理专业支持。深度响应"一带一路"倡议，通过民间协作助力国家双循环发展，助力中国企业与中国公民海外行稳致远。</p>
					</div>
				</div>
			</div>
		</section>

		<!-- 平台图展示区域 -->
		<section class="platform-section">
			<div class="container">
				<div class="platform-layout">
				<!-- Center logo -->
				<div class="center-logo">
					<img src="@/assets/images/ggrc-logo.png" alt="GGRC Logo">
				</div>
				
				<!-- Top row -->
				<div class="platform-row top-row">
					<div class="platform-card platform-card-border">
					<h3>江泰全球救援联盟</h3>
					</div>
					<div class="platform-card platform-card-border">
					<h3>江泰国际合作联盟</h3>
					</div>
				</div>
				
				<!-- Middle row -->
				<div class="platform-row middle-row">
					<div class="platform-card">
					<h3>大救星</h3>
					<p>全球救援智能云平台</p>
					</div>
					<div class="platform-card">
					<h3>优投网</h3>
					<p>全球投资综合服务平台</p>
					</div>
				</div>
				
				<!-- Bottom row -->
				<div class="platform-row bottom-row">
					<div class="platform-card">
					<h3>星使网络</h3>
					</div>
					<div class="platform-card">
					<h3>服务商&园区</h3>
					</div>
				</div>
				</div>
			</div>
		</section>

		<section class="forums-section">
			<div class="container">
				<div class="forums-container">
				<!-- Left Forum -->
					<div class="forum-card" v-for="(item, index) in lunTanData" :key="index">
						<h2 class="forum-title">{{ item.name }}</h2>
						<div class="forum-divider"></div>
						
						<div class="forum-content">
						<p>{{ item.description }}</p>
						
						<button class="more-btn" @click="goToUrl(item.actionUrl)">了解更多</button>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="guests-section">
			<div class="container">
				<h2 class="section-title">重磅嘉宾</h2>
				
				<div class="guest-carousel">
					<!-- First row of guests -->
					<div class="guest-row">
						<div class="guest-card" v-for="(guest, index) in guestsFirstRow" :key="'first-'+index">
							<div class="guest-image">
								<img :src="guest.image" :alt="guest.name">
							</div>
							<h3 class="guest-name">{{ guest.name }}</h3>
						</div>
					</div>
					
					<!-- Second row of guests -->
					<div class="guest-row">
						<div class="guest-card" v-for="(guest, index) in guestsSecondRow" :key="'second-'+index">
							<div class="guest-image">
								<img :src="guest.image" :alt="guest.name">
							</div>
							<h3 class="guest-name">{{ guest.name }}</h3>
						</div>
					</div>
				</div>
				
				<!-- Carousel indicators -->
				<div class="carousel-indicators">
					<span 
						v-for="indicator in 2" 
						:key="indicator-1" 
						:class="['indicator', { active: currentSlide === indicator-1 }]"
						@click="setSlide(indicator-1)">
					</span>
				</div>
			</div>
		</section>

		<!-- 嘉宾金句与精彩演讲 -->
		<section class="testimonials-section">
			<h2 class="section-title">嘉宾金句与精彩演讲</h2>
			
			<!-- 嘉宾金句滚动区域 - 类似用户评价的横向滚动 -->
			<div class="testimonial-container">
				<div class="testimonial-scroll">
					<div class="testimonial-row">
						<!-- First set of quotes -->
						<div v-for="(quote, index) in guestQuotes.slice(0, 4)" :key="'quote-row1-'+index" class="testimonial-card">
							<div class="testimonial-avatar">
								<img :src="quote.avatar" :alt="quote.name">
							</div>
							<div class="testimonial-content">
								<p class="testimonial-text">{{ quote.content }}</p>
							</div>
						</div>
						<!-- Duplicate the first set for seamless looping -->
						<div v-for="(quote, index) in guestQuotes.slice(0, 4)" :key="'quote-row1-dup-'+index" class="testimonial-card">
							<div class="testimonial-avatar">
								<img :src="quote.avatar" :alt="quote.name">
							</div>
							<div class="testimonial-content">
								<p class="testimonial-text">{{ quote.content }}</p>
							</div>
						</div>
					</div>
				</div>
				
				<div class="testimonial-scroll reverse">
					<div class="testimonial-row">
						<!-- First set of quotes -->
						<div v-for="(quote, index) in guestQuotes.slice(4, 8)" :key="'quote-row2-'+index" class="testimonial-card">
							<div class="testimonial-avatar">
								<img :src="quote.avatar" :alt="quote.name">
							</div>
							<div class="testimonial-content">
								<!-- <h4 class="testimonial-name">{{ quote.name }}</h4> -->
								<p class="testimonial-text">{{ quote.content }}</p>
							</div>
						</div>
						<!-- Duplicate the second set for seamless looping -->
						<div v-for="(quote, index) in guestQuotes.slice(4, 8)" :key="'quote-row2-dup-'+index" class="testimonial-card">
							<div class="testimonial-avatar">
								<img :src="quote.avatar" :alt="quote.name">
							</div>
							<div class="testimonial-content">
								<!-- <h4 class="testimonial-name">{{ quote.name }}</h4> -->
								<p class="testimonial-text">{{ quote.content }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container">
				<!-- 特色嘉宾卡片 -->
				<div class="featured-quotes">
					<el-carousel :interval="5000" arrow="always" indicator-position="outside">
						<el-carousel-item v-for="page in Math.ceil(featuredQuotes.length / 4)" :key="page">
							<div class="featured-quotes-row">
								<div 
									v-for="quote in getPageQuotes(page)" 
									:key="'featured-'+quote.id"
									class="featured-quote-card"
								>
									<div class="featured-quote-avatar">
										<img :src="quote.avatar" :alt="quote.name">
									</div>
									<h3 class="featured-quote-name">{{ quote.name }}</h3>
									<div class="featured-quote-content">
										<p>{{ quote.content }}</p>
									</div>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</section>

		<!-- 精彩瞬间 -->
		<section class="highlights-section">
			<h2 class="section-title">精彩瞬间</h2>
			<div class="testimonial-container">
				<div class="testimonial-scroll reverse">
					<div class="testimonial-row">
						<!-- First set of quotes -->
						<div v-for="(quote, index) in eventHighlights" :key="'quote-row1-'+index" class="highlights-card">
							<div class="highlights-avatar">
								<img :src="quote.image" :alt="quote.name">
							</div>
						</div>
						<!-- Duplicate the first set for seamless looping -->
						<div v-for="(quote, index) in eventHighlights" :key="'quote-row1-dup-'+index" class="highlights-card">
							<div class="highlights-avatar">
								<img :src="quote.image" :alt="quote.name">
							</div>
						</div>
					</div>
				</div>
				
				<div class="testimonial-scroll">
					<div class="testimonial-row">
						<!-- First set of quotes -->
						<div v-for="(quote, index) in eventHighlights" :key="'quote-row2-'+index" class="highlights-card">
							<div class="highlights-avatar">
								<img :src="quote.image" :alt="quote.name">
							</div>
						</div>
						<!-- Duplicate the second set for seamless looping -->
						<div v-for="(quote, index) in eventHighlights" :key="'quote-row2-dup-'+index" class="highlights-card">
							<div class="highlights-avatar">
								<img :src="quote.image" :alt="quote.name">
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 往届精彩专题视频 -->
		<section class="highlights-section">
			<h2 class="section-title">往届精彩专题视频</h2>
			<div class="testimonial-container">
				<div class="testimonial-scroll reverse">
					<div class="testimonial-row">
						<!-- First set of quotes -->
						<div v-for="(quote, index) in videoData" :key="'quote-row1-'+index" class="highlights-card">
							<div class="highlights-avatar" @click="openVideoModal(quote)">
								<img :src="quote.image" :alt="quote.videoName">
							</div>
						</div>
						<!-- Duplicate the first set for seamless looping -->
						<div v-for="(quote, index) in videoData" :key="'quote-row1-dup-'+index" class="highlights-card">
							<div class="highlights-avatar" @click="openVideoModal(quote)">
								<img :src="quote.image" :alt="quote.videoName">
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 视频播放弹窗 -->
		<el-dialog v-model="videoModalVisible" :title="currentVideo.videoName" width="80%" :fullscreen="isMobile" :before-close="closeVideoModal" class="video-dialog">
			<div class="video-container">
				<video 
					ref="videoPlayer"
					:src="currentVideo.videoShowId" 
					controls 
					autoplay
					class="responsive-video"
				></video>
			</div>
		</el-dialog>

  </div>
</template>

<script>
import { resultsService } from '@/service';
import $api from '@/api/urls'
export default {
	name: 'Home',
	data() {
		return {
			loopData0: [
				{ lanhutext0: '9,000+', lanhutext1: '累计参会嘉宾' },
				{ lanhutext0: '450+', lanhutext1: '累计演讲嘉宾' },
				{ lanhutext0: '5,000万+', lanhutext1: '在线观看人次' },
				{ lanhutext0: '2,100+', lanhutext1: '媒体报道' },
			],
			showTime: true,
			curStartTime: "2025-03-20 09:30:00",
			day: "0",
			hour: "00",
			min: "00",
			second: "00",
			currentSlide: 0,
			guestsFirstRow: [
				{ name: '沈开涛', image: require('@/assets/images/guests/01.jpg') },
				{ name: '龙永图', image: require('@/assets/images/guests/02.jpg') },
				{ name: '滕建群', image: require('@/assets/images/guests/03.jpg') },
				{ name: '李海涛', image: require('@/assets/images/guests/04.jpg') },
				{ name: '戚凯', image: require('@/assets/images/guests/05.jpg') }
			],
			guestsSecondRow: [
				{ name: '李翊文', image: require('@/assets/images/guests/06.jpg') },
				{ name: '魏建青', image: require('@/assets/images/guests/07.jpg') },
				{ name: '张倩楠', image: require('@/assets/images/guests/08.jpg') },
				{ name: '贾天楚', image: require('@/assets/images/guests/09.jpg') },
				{ name: '项菁', image: require('@/assets/images/guests/10.jpg') }
			],
			carouselInterval: null,
			// 嘉宾金句数据
			guestQuotes: [
				{ 
					name: '嘉宾1', 
					avatar: require('@/assets/images/guests/01.jpg'), 
					content: '坚持“走出去”发展的战略，破解“去中国化”的风险。' 
				},
				{ 
					name: '嘉宾2', 
					avatar: require('@/assets/images/guests/02.jpg'), 
					content: '“中国企业‘走出去’，最终会使得中国企业本身成为全球化的企业。' 
				},
				{ 
					name: '嘉宾3', 
					avatar: require('@/assets/images/guests/03.jpg'), 
					content: '在当前复杂多变的国际形势下，企业必须加强对外资产的保护，确保海外利益的安全.' 
				},
				{ 
					name: '嘉宾4', 
					avatar: require('@/assets/images/guests/04.jpg'), 
					content: '中国企业要走出去，实现与全世界的价值对接，成为一个真正的现代化的全球企业，这是一个时代的呼唤。' 
				},
				{ 
					name: '嘉宾5', 
					avatar: require('@/assets/images/guests/05.jpg'), 
					content: '中国企业要通过海外投资培养核心竞争力，实现价值链跃升，摆脱低端锁定，防止国内产业空心化。' 
				},
				{ 
					name: '嘉宾1', 
					avatar: require('@/assets/images/guests/01.jpg'), 
					content: '坚持从风险出发的理念，在“风控”中发现对外投资合作的商机。' 
				},
				{ 
					name: '嘉宾2', 
					avatar: require('@/assets/images/guests/02.jpg'), 
					content: '“当一个国家经济发展到一定程度，企业出海是历史必然。”' 
				},
				{ 
					name: '嘉宾3', 
					avatar: require('@/assets/images/guests/03.jpg'), 
					content: '“一带一路”倡议为企业“走出去”提供了广阔的空间和机遇。' 
				},
				{ 
					name: '嘉宾1', 
					avatar: require('@/assets/images/guests/01.jpg'), 
					content: '坚持专业化合作的方向，为企业高质量“走出去”保驾护航。' 
				},
				{ 
					name: '嘉宾5', 
					avatar: require('@/assets/images/guests/05.jpg'), 
					content: '在‘一带一路’高质量发展的阶段，风险变化是动态的，企业家们要客观看待、理性应对，方能行稳致远。' 
				},
				{ 
					name: '嘉宾4', 
					avatar: require('@/assets/images/guests/04.jpg'), 
					content: '中国企业出海不仅要在产品和组织上实现全球化，更要在战略部署上具备全球视野。' 
				}
			],
			
			// 特色嘉宾金句
			featuredQuotes: [
				{
					name: '沈开涛',
					avatar: require('@/assets/images/guests/01.jpg'),
					content: '风险防控是一个跨学科的专业领域，走出去企业必须依靠外部资源提供的专业服务，才能达到预防、转嫁、处置各类风险的目的。从全球角度看，对外投资发生风险是必然的；从概率上讲，发生在自己身上的风险是偶然的。很遗憾，很多企业不太懂得必然性存在于偶然性之中的风险规律，没有做好风险预防、应急预案、风险转嫁的准备，仍然选择风险自留，导致事后处置的难度和成本增加。因此，政府要鼓励和引导企业，用好商业保险的风险转嫁作用。同时，提供风险管控服务的机构，也应该率先与保险服务对接，帮助走出去企业守住抗风险的底线。'
				},
				{
					name: '龙永图',
					avatar: require('@/assets/images/guests/02.jpg'),
					content: '当一个国家的经济发展走到一定的程度，当企业发展到一定程度，企业出海已经成为历史的必然。中国企业走出去不仅仅是一个历史的必然，也是我国政府长期坚持改革开放的重要结果。并且，在国际经济形势相当严峻的情况下，中国将仍然坚持改革开放，而且越开越大。'
				},
				{
					name: '滕建群',
					avatar: require('@/assets/images/guests/03.jpg'),
					content: '要重新认识现在走出去的挑战，不能停在旧有思维模式上考虑今天走出去；做好投资地选择。在欧洲，我们应选择好方向。国内企业在非洲也取得很大成功；要做好内外循环的衔接；要精打细算，做好评估，因为环境变了，投资的每一步都要做出认真的选择；须加强外资产的保护，确保我们的海外利益安全。'
				},
				{
					name: '戚凯',
					avatar: require('@/assets/images/guests/05.jpg'),
					content: '全球的政治、经济、社会环境的迅猛复杂的变化，让中国的企业走出去，要站得住脚、赚到钱、回得来，带来了更高的挑战和更高的要求。危中有机，要安全也要发展，更好的发展才能最大限度的保障安全，提升安全意识、做好安全保障，稳中求进，行稳致远！'
				},
				{
					name: '李海涛',
					avatar: require('@/assets/images/guests/04.jpg'),
					content: '全球化的目标不仅是出海，更是成为能够整合全球资源、服务全球市场的真正全球化企业。这一过程通常历经五个阶段：从简单的出口，到初期的国际扩张，再到全面的国际运营，最终形成跨国和全球化的布局。全球型企业不仅拥有遍布全球的销售网络和运营中心，更在研发、制造、财务、风险管控等多个领域具备全球化的能力部署。同时，全球化的人才策略和文化融入也是不可或缺的组成部分。'
				},
				{
					name: '沈开涛',
					avatar: require('@/assets/images/guests/01.jpg'),
					content: '全力推动风险发布会的平台化和多元化。我们将在现有基础上，致力于把风险发布会打造成企业、行业和服务商的沟通交流平台，开辟出分享走出去经验、发现对外投资合作商机的窗口。我们还将响应国家号召，继续推动“政企研”合作，利用包括大救星、优投在内的第三方服务机构的专业资源，共建境外风险防控服务链，向企业提供高水平的境外安全风险咨询和防控服务。'
				}
			],
			
			// 精彩瞬间图片
			eventHighlights: [],
			lunTanData: [],
			videoData: [],
			fileDownload: $api.DOWNLOAD_FILE,//`api/res-svc/res/v3/download`,
			videoModalVisible: false,
			currentVideo: {},
			isMobile: false,
		}
	},
	mounted() {
		// this.startCarousel();
	},
	beforeUnmount() {
		this.stopCarousel();
	},
	created() {
		this.countTime();
		this.getHomePage();
		this.isMobilePhone();
	},
	methods: {
		isMobilePhone(){
			if(/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(navigator.userAgent)) {
				this.isMobile = true;
			}
		},
		// 倒计时
		countTime() {
			// 获取当前时间
			let date = new Date();
			const currentYear = date.getFullYear(); // 获取当前年份
			this.curStartTime = currentYear+'-03-20 09:30:00'
			let now = date.getTime();
			// 设置截止时间
			let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
			let end = endDate.getTime();
			// 时间差
			let leftTime = end - now;
			// 定义变量 d,h,m,s保存倒计时的时间
			if (leftTime >= 0) {
				// 天
				this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
				// 时
				let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
				this.hour = h < 10 ? "0" + h : h;
				// 分
				let m = Math.floor((leftTime / 1000 / 60) % 60);
				this.min = m < 10 ? "0" + m : m;
				// 秒
				let s = Math.floor((leftTime / 1000) % 60);
				this.second = s < 10 ? "0" + s : s;
			} else {
				this.day = 0;
				this.hour = "00";
				this.min = "00";
				this.second = "00";
			}
			// 等于0的时候不调用
			if (
				Number(this.hour) === 0 &&
				Number(this.day) === 0 &&
				Number(this.min) === 0 &&
				Number(this.second) === 0
			) {
				this.showTime = false;
				return;
			} else {
				// 递归每秒调用countTime方法，显示动态时间效果,
				setTimeout(this.countTime, 1000);
			}
		},
		startCarousel() {
			this.carouselInterval = setInterval(() => {
				this.currentSlide = (this.currentSlide + 1) % 4;
			}, 5000); // Change slide every 5 seconds
		},
		stopCarousel() {
			clearInterval(this.carouselInterval);
		},
		setSlide(index) {
			this.currentSlide = index;
			if(index === 1){
				this.guestsFirstRow = [
					{ name: '张启明', image: require('@/assets/images/guests/11.jpg') },
					{ name: '徐晓天', image: require('@/assets/images/guests/12.jpg') },
					{ name: '和静彬', image: require('@/assets/images/guests/13.jpg') },
					{ name: '聂聪', image: require('@/assets/images/guests/14.jpg') },
					{ name: '常美玲', image: require('@/assets/images/guests/15.jpg') }
				];
				this.guestsSecondRow = [];
				this.stopCarousel();
			} else {
				this.guestsFirstRow = [
					{ name: '沈开涛', image: require('@/assets/images/guests/01.jpg') },
					{ name: '龙永图', image: require('@/assets/images/guests/02.jpg') },
					{ name: '滕建群', image: require('@/assets/images/guests/03.jpg') },
					{ name: '李海涛', image: require('@/assets/images/guests/04.jpg') },
					{ name: '戚凯', image: require('@/assets/images/guests/05.jpg') }
				],
				this.guestsSecondRow = [
					{ name: '李翊文', image: require('@/assets/images/guests/06.jpg') },
					{ name: '魏建青', image: require('@/assets/images/guests/07.jpg') },
					{ name: '张倩楠', image: require('@/assets/images/guests/08.jpg') },
					{ name: '贾天楚', image: require('@/assets/images/guests/09.jpg') },
					{ name: '项菁', image: require('@/assets/images/guests/10.jpg') }
				],
				this.stopCarousel();
			}
			// this.startCarousel();
		},
		// Get quotes for a specific page
		getPageQuotes(page) {
			const startIndex = (page - 1) * 4;
			const endIndex = startIndex + 4;
			return this.featuredQuotes.slice(startIndex, endIndex);
		},
		// 获取首页数据
		getHomePage() {
			let params = {
				channelNo: 'home',
				sysCode: 'ceggrc-web-2025',
				homeDisplayParams: [
					// 走出去风险发布会论坛
					{ code: "index01", ps: 2, type: "ads" },
					// 精彩瞬间
					{ code: "index02", ps: 10, type: "ads" },
					{ code: "index-sp", ps: 10, type: "video" },
				]
			};
			resultsService.getHomePage(params).then(res => {
				// 精彩瞬间
				this.eventHighlights = this.getModelData("index02", "ads", res.data.data).map(item => {
					item.image = this.fileDownload + "?fileId=" + item.fileId + "&free=1"; // 封面图片全路径
					return item;
				});
				//论坛
				this.lunTanData = this.getModelData('index01', 'ads', res.data.data).map(item=>{ return item  })
				//视频
				this.videoData = this.getModelData('index-sp', 'video', res.data.data).map(item=> {
						item.image = this.fileDownload + "?fileId=" + item.fileId + "&free=1"; // 封面图片全路径
						item.videoShowId = this.fileDownload + "?fileId=" + item.videoId + "&free=1"; // 视频全路径
						return item;
					}
				)
				console.log(res);
			});
		},
		// 获取指定数据
		getModelData(code, type, data) {
			let obj = data.find(item => {
				return item.code === code && item.type === type;
			});
			if (obj && obj.list) {
				return obj.list;
			}
			return [];
		},
		goToUrl(url) {
			window.open(url, '_blank');
		},
		openVideoModal(video) {
			this.currentVideo = video;
			this.videoModalVisible = true;
		},
		closeVideoModal() {
			this.videoModalVisible = false;
		}
	}
}
</script>

<style scoped>
.home {
  width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
}

.btn-primary {
  background-color: #c7000b;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #a70009;
}

/* 通用部分样式 */
.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  padding-bottom: 1rem;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #c7000b;
}

.hero-container {
  width: 100%;
  background: linear-gradient(to right, #001a66, #003399);
  background-image: url('@/assets/images/bg-1.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 60px 20px;
  text-align: center;
  margin-top: 70px;
  min-height: 550px;
}
.hero-container1 {
	background: none;
	background-image: url('@/assets/images/bg-top1.jpg');
	background-size: cover;
	background-position: center;
	min-height: 550px;
	width: 100%;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
}

.main-title {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 15px;
}

.sub-title {
  font-size: 20px;
  margin-bottom: 40px;
}

.stats-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}
.hero-container1 .hero-content {
	background: none;
	margin-top: 210px;
}
.hero-container1 .countdown-box {
  background: none;
}

.stat-box {
  background-color: rgba(0, 51, 153, 0.7);
  border-radius: 10px;
  padding: 20px 30px;
  min-width: 180px;
}

.stat-number {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 16px;
}

.footer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
}

.countdown-box {
  background-color: rgba(0, 51, 153, 0.7);
  border-radius: 30px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
}

.countdown-label {
  margin-right: 10px;
  font-size: 18px;
}

.countdown-text {
  font-size: 18px;
  margin: 0 5px;
}

.countdown-number {
  color: #ffc107;
  font-size: 28px;
  font-weight: bold;
}

.countdown-timer {
  color: #ffc107;
  font-size: 28px;
  font-weight: bold;
  margin-left: 5px;
}

.year-range {
  font-size: 24px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .main-title {
    font-size: 32px;
  }
  
  .sub-title {
    font-size: 18px;
  }
  
  .stats-container {
    gap: 15px;
  }
  
  .stat-box {
    min-width: 140px;
    padding: 15px 20px;
  }
  
  .stat-number {
    font-size: 26px;
  }
  
  .footer-container {
    flex-direction: column;
    gap: 20px;
  }
}

@media (max-width: 480px) {
	.hero-container {
		margin-top: 20px;
	}
	.stats-container ,.sub-title{
		margin-bottom: 20px;
	}
	.stat-box {
		padding: 10px 20px;
	}
	.footer-container {
		gap: 0px;
	}
	.stat-number {
		font-size: 20px;
	}
  .main-title {
    font-size: 28px;
  }
  
  .sub-title {
    font-size: 16px;
  }
  
  .stats-container {
    flex-direction: row;
    align-items: center;
  }
  
  .stat-box {
    width: 47%;
  }
  
  .countdown-box {
    padding: 8px 15px;
  }
  
  .countdown-label, .countdown-text {
    font-size: 16px;
  }
  
  .countdown-number, .countdown-timer {
    font-size: 22px;
  }
  
  .year-range {
    font-size: 20px;
  }
}
.features-section {
  padding: 60px 0;
  background-color: #f8f9fa;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.feature-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.feature-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.feature-text {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  flex-grow: 1;
}

/* Responsive styles */
@media (max-width: 1024px) {
	.container {
		padding: 0 10px;
	}
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
	.container {
		padding: 0 10px;
	}
  .features-section {
    padding: 40px 0;
  }
  
  .feature-card {
    padding: 15px;
  }
}

@media (max-width: 576px) {
	.container {
		padding: 0 10px;
	}
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .feature-title {
    font-size: 16px;
  }
  
  .feature-text {
    font-size: 13px;
  }
}
.platform-section {
  background: url('@/assets/images/network-bg.png') 100% 100% no-repeat;
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}


.platform-layout {
  display: grid;
  grid-template-areas:
    ". top-row ."
    "middle-left center middle-right"
    ". bottom-row .";
  grid-template-columns: 1fr auto 1fr;
  grid-gap: 20px;
  justify-items: center;
  align-items: center;
  position: relative;
}

.center-logo {
  grid-area: center;
  width: 180px;
  height: 180px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  padding: 10px;
  z-index: 2;
}

.center-logo img {
  width: 85%;
  height: 85%;
  object-fit: contain;
}

.platform-row {
  display: flex;
  gap: 220px;
  justify-content: center;
  width: 100%;
}

.top-row {
  grid-area: top-row;
}

.middle-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  grid-area: center;
}

.middle-row .platform-card:first-child {
  grid-area: middle-left;
  justify-self: end;
}

.middle-row .platform-card:last-child {
  grid-area: middle-right;
  justify-self: start;
}

.bottom-row {
  grid-area: bottom-row;
}

.platform-card {
	background: rgba(0,0,0,0.23);
	border-radius: 8px;
	border-radius: 6px;
	padding: 15px 25px;
	color: white;
	text-align: center;
	min-width: 200px;
	transition: all 0.3s ease;
}
.platform-card-border {
	border: 1px solid;
	border-image: linear-gradient(138deg, rgba(246, 230, 14, 1), rgba(236, 113, 4, 1)) 1 1;
}

.platform-card:hover {
  background-color: rgba(0, 40, 100, 0.9);
  transform: translateY(-3px);
}

.platform-card h3 {
  margin: 0 0 5px;
  font-size: 18px;
  font-weight: 500;
}

.platform-card p {
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
}

/* Forums Section Styles */
.forums-section {
  /* background-color: #0046b8; */
  background: url('@/assets/images/bg-2.png') 100% 100% no-repeat;
  background-size: cover;
  padding: 40px 0 15px;
  position: relative;
}

.forums-container {
  display: flex;
  gap: 30px;
}

.forum-card {
  flex: 1;
  /* background-color: rgba(0, 40, 100, 0.3); */
  border-radius: 6px;
  padding: 25px;
  color: white;
}

.forum-title {
  text-align: center;
  font-size: 22px;
  margin: 0 0 15px;
}

.forum-divider {
  height: 2px;
  background-color: white;
  width: 60px;
  margin: 0 auto 20px;
}

.forum-content {
  font-size: 14px;
  line-height: 1.6;
}

.forum-content p {
  margin-bottom: 10px;
}

.forum-content strong {
  font-weight: 500;
}

.more-btn {
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
  transition: all 0.3s ease;
}

.more-btn:hover {
  background-color: white;
  color: #0046b8;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .platform-layout {
    grid-template-columns: 1fr;
	grid-gap: 0px;
  }
  
  .platform-row {
    flex-direction: row;
    gap: 80px;
    align-items: center;
  }
  
  .forums-container {
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  .platform-card {
    min-width: 160px;
    padding: 12px;
  }
  
  .center-logo {
    width: 150px;
    height: 150px;
  }
  
  .forum-card {
    padding: 20px;
  }
  
  .forum-title {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .platform-section {
    padding: 40px 0;
  }
  
  .center-logo {
    width: 120px;
    height: 120px;
  }
  
  .platform-card h3 {
    font-size: 16px;
  }
  
  .platform-card p {
    font-size: 12px;
  }
  
  .forum-content {
    font-size: 13px;
  }
}
.guests-section {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.section-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  color: #333;
  position: relative;
}

.guest-carousel {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  transition: transform 0.5s ease;
  display: flex;
  flex-direction: column;
}

.guest-row {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.guest-card {
  width: 180px;
  text-align: center;
  transition: transform 0.3s ease;
}

.guest-card:hover {
  transform: translateY(-5px);
}

.guest-image {
  width: 100%;
  height: 220px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.guest-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.guest-card:hover .guest-image img {
  transform: scale(1.05);
}

.guest-name {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.indicator {
  width: 30px;
  height: 3px;
  background-color: #ddd;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator.active {
  background-color: #0056b3;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .guest-card {
    width: 160px;
  }
  
  .guest-image {
    height: 200px;
  }
}

@media (max-width: 768px) {
  .guest-row {
    gap: 15px;
    flex-wrap: wrap;
  }
  
  .guest-card {
    width: calc(19% - 10px);
  }
  
  .guest-image {
    height: auto;
  }
}

@media (max-width: 576px) {
  .guest-card {
    width: calc(19% - 10px);
  }
  
  .guest-image {
    height: auto;
  }
  
  .guest-name {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
	.container {
		padding: 0 10px;
	}
  .guest-row {
    gap: 10px;
  }
  
  .guest-card {
    width: calc(19% - 5px);
  }
  
  .guest-image {
    height: auto;
  }
}
/* 嘉宾金句与精彩演讲 */
.testimonials-section {
  padding: 30px 0;
  background-color: #f9f9f9;
  overflow: hidden;
}

.testimonial-container {
  margin: 20px 0;
  overflow: hidden;
  position: relative;
}

.testimonial-scroll {
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
}

.testimonial-row {
  display: flex;
  animation: scroll 30s linear infinite;
  width: max-content;
}

.testimonial-scroll.reverse .testimonial-row {
  animation: scroll-reverse 30s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); /* Only move half way since we duplicated the content */
  }
}

@keyframes scroll-reverse {
  0% {
    transform: translateX(-50%); /* Start from halfway point */
  }
  100% {
    transform: translateX(0);
  }
}

.testimonial-card {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 100px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-right: 20px;
  padding-right: 25px;
  min-width: 300px;
  max-width: 400px;
  transition: transform 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-5px);
}
.highlights-card {
	display: flex;
	align-items: center;
	border-radius: 5px;
	margin-right: 30px;
	width: 360px;
	height: 200px;
	transition: transform 0.3s ease;
}
.highlights-avatar {
	width: 360px;
	height: 200px;
}
.highlights-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
  flex-shrink: 0;
}

.testimonial-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-content {
  flex: 1;
}

.testimonial-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.testimonial-text {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.featured-quotes {
  margin-top: 40px;
}

.featured-quotes-row {
  display: flex;
  justify-content: left;
  height: 100%;
  padding: 0 60px;
}

.featured-quote-card {
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  text-align: center;
  width: calc(25% - 15px);
  height: 100%;
  display: grid;
  flex-direction: column;
  transition: transform 0.3s ease;
  margin-right: 20px;
}

.featured-quote-card:hover {
  transform: translateY(-5px);
}

.featured-quote-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 10px;
}

.featured-quote-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.featured-quote-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.featured-quote-content {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  text-align: left;
  /* flex-grow: 1; */
  overflow-y: auto;
}

/* Responsive styles */
@media (max-width: 992px) {
  .featured-quote-card {
    padding: 12px;
  }
  
  .featured-quote-avatar {
    width: 40px;
    height: 40px;
  }
  
  .featured-quote-name {
    font-size: 15px;
    margin-bottom: 8px;
  }
  
  .featured-quote-content {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
	.el-carousel[data-v-fae5bece] {
        height: 480px;
    }
	/deep/.el-carousel__container {
		height: 460px;
	}
  .featured-quotes-row {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
    padding: 15px;
  }
  
  .featured-quote-card {
    width: calc(45% - 10px);
    margin-bottom: 15px;
    height: 200px;
  }
}

@media (max-width: 576px) {
  .testimonials-section, .highlights-section {
    padding: 20px 0;
  }
  
  .section-title {
    font-size: 22px;
  }
  
  .testimonial-card {
    min-width: 220px;
    padding: 12px 15px;
  }
  
  .testimonial-avatar {
    width: 40px;
    height: 40px;
  }
  
  .featured-quote-content {
    font-size: 13px;
  }
  
  .thumbnail-row {
    flex-wrap: wrap;
  }
  
  .thumbnail {
    width: 48%;
    margin-bottom: 10px;
  }
}


.video-title {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 视频弹窗样式 */
.video-container {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 宽高比 */
  height: 0;
  overflow: hidden;
}

.responsive-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 深度选择器修改 Element Plus 弹窗样式 */
:deep(.video-dialog .el-dialog__body) {
  padding: 0;
}

:deep(.video-dialog .el-dialog__header) {
  padding: 15px 20px;
}

/* 响应式调整 */
@media (max-width: 767px) {
  .highlights-card {
    width: 160px;
    margin-right: 12px;
  }
  
  .play-icon {
    width: 40px;
    height: 40px;
  }
  
  .play-icon i {
    font-size: 20px;
  }
  
  .video-title {
    font-size: 12px;
  }
  
  :deep(.video-dialog .el-dialog__header) {
    padding: 10px 15px;
  }
}
</style> 